import React from 'react'
import PropTypes from 'prop-types'
import InputMask from 'react-input-mask'

class FormInput extends React.Component { // eslint-disable-line react/prefer-stateless-function
  render() {
    let label = null
    if (this.props.label !== null) {
      label = <label htmlFor={this.props.id}>{this.props.label}</label>
    }
    return (
      <div className={`form-group my-3 has-${this.props.validation}`}>
        {label}
        <InputMask mask={this.props.mask} maskChar={this.props.maskChar} formatChars={this.props.formatChars} required={this.props.required} value={this.props.value} onChange={this.props.onChange} type={this.props.type} name={this.props.name} placeholder={this.props.placeholder} className={`${'form-control form-control-'}${this.props.validation}`} />
        <div className={`form-control-feedback ${this.props.validation == null || this.props.validation === 'success' ? 'd-none' : 'null'}`}>{this.props.feedbackText}</div>
      </div>
    )
  }
}

FormInput.propTypes = {
  validation: PropTypes.string,
  id: PropTypes.number,
  feedbackText: PropTypes.string,
  formatChars: PropTypes.object,
  value: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
  mask: PropTypes.string,
  maskChar: PropTypes.object,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
}

export default FormInput



// WEBPACK FOOTER //
// ./client/components/FormInput.js